import React from 'react';
import { alpha, styled } from '@mui/material/styles';
import {AppBar, Toolbar, IconButton, Typography, Box, List, ListItemIcon, ListItemText, Drawer, Avatar, ListItemButton} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch, useSelector } from 'react-redux';
import { admin, setPage } from '../../storeredux';

const MenuIc = styled(IconButton)(({theme}) => ({
  marginRight: theme.spacing(1)
}))

const Distance = styled('div')(({theme}) => ({
  flexGrow: 1,
  [theme.breakpoints.up(1000)]: {
    flexGrow: 0
  }
}))

const Title = styled(Typography)(({theme}) => ({
  display: 'none',
  [theme.breakpoints.up(250)]: {
    display: 'block',
  }
}))

const ImgAvt = styled(Avatar)(({theme}) => ({
  width: theme.spacing(5),
  height: theme.spacing(5),
  marginRight: '5px'
}))

const Box1 = styled(Box)(({theme}) => ({
  display: 'none',
  [theme.breakpoints.up(500)]: {
    display: 'flex',
  }
}))

export default function Header(props) {
  const {path1,path2,icon1,icon2,desc1,desc2} = props
  const user = useSelector(admin)
  const dispatch = useDispatch()
  const [anchor,setAnchor] = React.useState(null);
  const [color, setColor] = React.useState();
  var clr = ['blue','deepOrange', 'red', 'purple', 'orange', 'amber','indigo'];

  React.useEffect(()=>{
    // getInfoDev(
    //   setResp
    // );
    setColor(clr[Math.floor(Math.random()*clr.length)]);
  },[])

  const handleMenuOpen = (event) => {
    setAnchor(event.currentTarget);
  }

  const handleMenuClose = () => {
    setAnchor(null);
  }

  const handleHome = (event) => {
    dispatch(setPage(path1))
    if(Boolean(anchor))
      return handleMenuClose();
  }

  const handleInfoDev = (event) => {
    dispatch(setPage(path2))
    if(Boolean(anchor))
      return handleMenuClose();
  }

  const menuId2 = "dev-menu";
  const renderMenuDev = (
     <List>
      <ListItemButton onClick={handleHome}>
        <ListItemIcon color="inherit">
         {icon1}
        </ListItemIcon>
        <ListItemText>{desc1}</ListItemText>
      </ListItemButton>
      <ListItemButton onClick={handleInfoDev}>
        <ListItemIcon color="inherit">
          {icon2}
        </ListItemIcon>
        <ListItemText>{desc2}</ListItemText>
      </ListItemButton>
     </List>
  );

  // const renderMenuDevmin = (
  //    <MenuList>
  //     <MenuItem onClick={handleCloseInfo}>
  //       <ListItemIcon color="inherit">
  //         <AccountCircleIcon/>
  //       </ListItemIcon>
  //       <ListItemText>{user.name}</ListItemText>
  //     </MenuItem>
  //    </MenuList>
  // );

  return(
    <>
      <AppBar sx={{maxWidth: '100vw',left:0,backgroundColor: alpha("#00cc66", 0.7)}}>
        <Toolbar>
          <React.Fragment>
            <MenuIc
              edge="start"
              aria-controls={menuId2}
              aria-haspopup="true"
              onClick={handleMenuOpen}
              color="inherit"
              aria-label="open drawer"
            >
              <MenuIcon />
            </MenuIc>
            <Drawer anchor='left' open={Boolean(anchor)} onClose={handleMenuClose}>
              {renderMenuDev}
            </Drawer>
          </React.Fragment>
          <Distance />
          <Title variant="body1" noWrap>
            <Typography component={'span'} variant='h6' style={{color:'#b3ff66'}}>MPQ</Typography>
            <Typography component={'span'} variant='h6' style={{color:'#ffff00'}}> UMS</Typography>
            <Typography component={'span'} variant='caption'> Data Center</Typography>
          </Title>
          <div style={{flexGrow:1}}/>
          <Box justifyContent='right' alignItems='center' display='flex'>
            <Box1 justifyContent='center' alignItems='center' display='flex'>
              <ImgAvt style={{backgroundColor: color}}>{user.name.charAt(0)}</ImgAvt>              
              <Box>
                <Box>
                  <Typography noWrap style={{textAlign:'left', fontSize:'15px'}}>
                    {user.name}
                  </Typography>
                </Box>
              </Box>
            </Box1>
          </Box>
        </Toolbar>
      </AppBar>
      {/* <Box2>
        <IconButton onClick={handleClickInfo}>
          <InfoIcon fontSize='large' color='primary'/>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleCloseInfo}
        >
          {renderMenuDevmin}
        </Menu>
      </Box2> */}
    </>
  )
}
